import { AppUser } from '../../views/App/App';
import axios from 'axios';
import { ALL_LIMIT } from '../../consts/table';

export function sendFreeNotification(user: AppUser, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios.post(`${window.apiBase}/admin/notifications/free`, data, config).then(response => {
    return response.data;
  });
}

export function getNotifications(user: AppUser, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: { filter },
  };

  return axios.get(`${window.apiBase}/admin/notifications`, config).then(response => {
    return response.data;
  });
}

export function getNotificationsCount(user: AppUser, where?) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: typeof where !== 'undefined' ? { filter: { where } } : undefined,
  };

  return axios.get(`${window.apiBase}/admin/notifications/count`, config).then(response => {
    return response.data;
  });
}

export function getAllNotifications(user: AppUser, where?) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: {
        where: where || {},
        limit: ALL_LIMIT,
        skip: 0,
      },
    },
  };

  return axios.get(`${window.apiBase}/admin/notifications`, config).then(response => {
    return response.data;
  });
}
